module.exports = __webpack_public_path__ + "static/img/1958_05_16_NYWorld-Telegram_Review.488d619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_05_16_NYWorld-Telegram_Review.jpg
// module id = 4euZ
// module chunks = 0